import { Injectable } from '@angular/core';
import { FieldType } from '@sla-ng/ui-material';
import { ICostAccountingDialogLayout } from '../../models/layout/cost-accounting-dialog-layout.model';
import { ICostAccountingLayout } from '../../models/layout/cost-accounting-layout.model';
import { ICostTypeCostLayout } from '../../models/layout/cost-type-cost-layout.model';
import { CostAccountingFacade } from '../facades/cost-accounting/cost-accounting.facade';

@Injectable({
    providedIn: 'root',
})
export class CostAccountingLayoutService {

    constructor(protected myCostAccountingFacade: CostAccountingFacade) {
    }

    public getCostAccountingLayout(): ICostAccountingLayout {
        return {
            columns: [ 'name', 'costAccountingType', 'from', 'to', 'progress', 'actions' ],
            filterFields: [
                {
                    type: FieldType.select,
                    label: 'app.page.cost-accounting.type-filter.label',
                    field: 'typeFilter',
                    withClearButton: true,
                    selectData: {
                        options: this.myCostAccountingFacade.fetchCostAccountingTypes(),
                        valueKey: 'id',
                        labelKeys: [ 'name' ],
                    },
                },
                { field: 'dateFilter', type: FieldType.daterange, label: 'app.page.cost-accounting.date-filter.label', withClearButton: true },
            ],

        };
    }

    public getCostTypeCostLayout(): ICostTypeCostLayout {
        return {
            costTypeCostColumns: [ 'costType.name', 'costCt' ],
        };
    }

    public getCostAccountingDialogLayout(): ICostAccountingDialogLayout {
        return {
            dialogNameField: {
                type: FieldType.text,
                label: 'app.dialog.cost-accounting.name.label',
                field: 'name',
            },
            dialogDateField: {
                field: 'dateRange',
                label: 'app.dialog.cost-accounting.date-range.label',
                type: FieldType.daterange,
            },
            dialogTypeSelectionField: {
                type: FieldType.select,
                label: 'app.dialog.cost-accounting.type.label',
                field: 'typeFilter',
                selectData: {
                    options: this.myCostAccountingFacade.fetchCostAccountingTypes(),
                    valueKey: 'id',
                    labelKeys: [ 'name' ],
                },
            },
        };
    }
}
